<div
  [ngClass]="{
    'untouched-input': !isInvalid && !isValid,
    'invalid-input': isInvalid && !isValid,
    'valid-input': isValid && !isInvalid,
    'round-corner': roundCorner
  }"
  class="input-container"
>
  <div *ngIf="!!title" class="label" [style.color]="labelColor">{{ title }}</div>

  <ion-input
    *ngIf="!type"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    [ngStyle]="{ 'font-weight': boldInput ? '700' : '400' }"
    placeholder="{{ placeholder }}"
    [disabled]="isDisabled"
    [readonly]="readonly"
  ></ion-input>

  <ion-input
    *ngIf="type === 'secretKey'"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    [ngStyle]="{ 'font-weight': boldInput ? '700' : '400' }"
    placeholder="{{ placeholder }}"
    [disabled]="isDisabled"
  ></ion-input>

  <ion-input
    *ngIf="type === 'email'"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    [ngStyle]="{ 'font-weight': boldInput ? '700' : '400' }"
    placeholder="{{ placeholder }}"
    [disabled]="isDisabled"
  ></ion-input>

  <ion-input
    *ngIf="type === 'password'"
    type="{{ showPassword ? 'text' : 'password' }}"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    [ngStyle]="{ 'font-weight': boldInput ? '700' : '400' }"
    placeholder="{{ placeholder }}"
    [disabled]="isDisabled"
  >
    <div (click)="toggleShowPassword()" class="password-icon">
      <img
        [src]="
          showPassword ? 'assets/icon/eye-crossed.svg' : 'assets/icon/eye.svg'
        "
        alt=""
      />
    </div>
  </ion-input>

  <ion-input
    *ngIf="type === 'numeric'"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    pattern="[0-9]*"
    [inputmode]="'numeric'"
    [ngStyle]="{ 'font-weight': boldInput ? '700' : '400' }"
    placeholder="{{ placeholder }}"
    [disabled]="isDisabled"
  ></ion-input>

  <ion-input
    *ngIf="type === 'inn'"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    [maxlength]="12"
    [minlength]="10"
    [inputmode]="'numeric'"
    placeholder="{{ placeholder }}"
    [disabled]="isDisabled"
  >
  </ion-input>

  <app-sdiz-input
    *ngIf="type === 'sdiz'"
    [formControl]="control"
  >
  </app-sdiz-input>

  <ion-input
    *ngIf="type === 'carNumber'"
    [maskito]="carNumberMask"
    [maskitoElement]="maskPredicate"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    [minlength]="7"
    placeholder="A123БВ 123"
    [disabled]="isDisabled"
  ></ion-input>

  <ion-input
    *ngIf="type === 'trailerNumber'"
    [maskito]="trailerNumberMask"
    [maskitoElement]="maskPredicate"
    [(ngModel)]="inputValue"
    (ngModelChange)="updateValue()"
    (paste)="onPaste($event)"
    [minlength]="8"
    placeholder="AА1234 999"
    [disabled]="isDisabled"
  ></ion-input>

  <ion-input
    *ngIf="type === 'phone'"
    [maskito]="phoneMask"
    [maskitoElement]="maskPredicate"
    [(ngModel)]="inputValue"
    (ionInput)="updateValue()"
    (paste)="onPaste($event)"
    inputmode="numeric"
    placeholder="+7 (xxx) xxx-xx-xx"
    [disabled]="isDisabled"
  ></ion-input>

  <div *ngIf="type === 'calendar'">
    <div
      class="calendar"
      (click)="openDatePicker()"
      [ngClass]="{
        'calendar-filled': !!inputValue,
        'calendar-reset': !inputValue && control.dirty
      }"
    >
      <img src="../../../assets/icon/calendar.svg" alt="" />
      <span *ngIf="inputValue" class="selectedDate">{{
        inputValue | date : 'dd.MM.yyyy'
      }}</span>
      <span
        *ngIf="!inputValue"
        [ngClass]="{ 'calendar-error-text': control.dirty }"
        >ДД/ММ/ГГГГ</span
      >
    </div>
  </div>

  <div *ngIf="showDatePicker">
    <div class="calendar-wrapper" [@fadeIn]>
      <ion-datetime
        [(ngModel)]="datePickerValue"
        (ionChange)="setDate()"
        (ionCancel)="clearDatePick()"
        [firstDayOfWeek]="1"
        presentation="date"
        [showDefaultButtons]="false"
        [max]="currentDate"
      >
      </ion-datetime>
    </div>
  </div>

  <div *ngIf="type === 'weight'" class="weight-input">
    <img class="weight-icon" src="../../../assets/icon/scale-icon.svg" alt="" />
    <span>кг</span>
    <ion-input
      type="number"
      [(ngModel)]="inputValue"
      (ngModelChange)="weightInputValueChanged()"
      (ionBlur)="normalizeWeightOnBlur()"
      (paste)="onPaste($event)"
      pattern="[0-9]*"
      [inputmode]="'numeric'"
      [min]="1"
      [disabled]="isDisabled"
    ></ion-input>
  </div>

  <div
    *ngIf="isInvalid && type && !customErrorsFieldTypes.includes(type)"
    class="error-message"
  >
    Неправильно заполнено поле
  </div>
  <div
    *ngIf="isInvalid && type === 'password' && control.errors.pattern"
    class="error-message"
  >
    Пароль содержит недопустимые символы
  </div>
  <div
    *ngIf="isInvalid && type === 'password' && control.errors.mismatch"
    class="error-message"
  >
    Пароли не совпадают
  </div>
  <div
    *ngIf="isInvalid && type === 'inn' && control.errors.alreadyExist"
    class="error-message"
  >
    Пользователь с таким ИНН уже зарегистрирован
  </div>
  <div
    *ngIf="isInvalidTaxNumber"
    class="error-message"
  >
    Неправильный ИНН
  </div>
  <div
    *ngIf="isInvalid && type === 'inn' && control.errors.incorrect"
    class="error-message"
  >
    {{ control.errors.incorrect }}
  </div>
  <div
    *ngIf="isInvalid && type === 'email' && control.errors.alreadyExist"
    class="error-message"
  >
    Пользователь с таким Email уже зарегистрирован
  </div>
  <div
    *ngIf="isInvalid && type === 'email' && control.errors.pattern"
    class="error-message"
  >
    Некорректный адрес электронной почты
  </div>
  <div
    *ngIf="isInvalid && type === 'secretKey' && control.errors.shortCode"
    class="error-message"
  >
    Секретный код должен содержать 32 символа
  </div>
  <div
    *ngIf="type === 'sdiz' && control.touched && control.invalid"
    class="error-message"
  >
    Неправильно заполнено поле
  </div>
</div>
